import { LoadingScreen } from "@/components/loading-screen";
import { Logo } from "@/components/logo";

export function PreCallLoading() {
  return (
    <div>
      <Logo className="mb-4 inline-block" />
      <p className="text-2xl text-foreground">Getting ready...</p>
      <p className="text-sm text-muted">
        You will be able to join the call just in the moment
      </p>
      <LoadingScreen className="mt-4" />
    </div>
  );
}
